import * as angular from 'angular';
import { MeurhSolicitacoesalteracoesenderecosFormController } from './solicitacoesalteracoesenderecos.form.controller';

export class MeurhSolicitacoesalteracoesenderecosFormComponent implements angular.IComponentOptions {
	static selector = 'meurhSolicitacoesalteracoesenderecosFormComponent';
	static controller = MeurhSolicitacoesalteracoesenderecosFormController;
	static template = require('!!html-loader!./solicitacoesalteracoesenderecos.form.html');
	static transclude = true;
	static bindings = {
		entity: '<',
		form: '<',
		busy: '=',
		action: '<'
	};
}
